import { getFormattedPower } from '@/shared/utils/formatters';

type HashrateCellProps = {
  value: number,
}

const HashrateCell = (props: HashrateCellProps) => {
  const { value } = props;
  return getFormattedPower(value);
}

export default HashrateCell;
